export default __webpack_public_path__ + "static/media/frame.1255e56d.svg";